var _desc, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbstractAvatar15SquareStreamlineAbstract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 513 513",
    height: 100,
    width: 100,
    strokeWidth: 1,
    id: "Abstract-Avatar-15-Square--Streamline-Abstract.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Abstract Avatar 15 Square Streamline Emoji: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M.694.871h512v512h-512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3290ff",
    d: "m279.432 143.523 74.679-70.9332 74.68 70.9332 50.44-42.56 32.786 83.094 93.313-14.187-23.959 103.36 94.575 40.533-63.05 103.36 40.352 62.827-71.877 48.64-227.26-4.292-227.26 4.292-71.8767-48.64 40.352-62.827-63.0499-103.36 94.5746-40.533-23.959-103.36 93.314 14.187 32.786-83.094 50.44 42.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    d: "M246.276 328.59c16.57 15.998 43.433 16 60 .004l-60-.004Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 16,
    d: "M252.276 260.59c-9.941 10.665-26.059 10.667-36 .003"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 16,
    d: "M336.276 260.59c-9.941 10.665-26.059 10.667-36 .003"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M0 0h512v512H0z",
    transform: "translate(.276 .59)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractAvatar15SquareStreamlineAbstract);
export default __webpack_public_path__ + "static/media/Abstract-Avatar-15-Square--Streamline-Abstract.c03fd0b5adfce9acb3178d43e998f1f3.svg";
export { ForwardRef as ReactComponent };